<template>
  <div class="summernote-display" v-html="processedContent"></div>
</template>

<script setup>
import { computed } from 'vue';
import { shortenLinks } from '@/shared/functions/shortenLinks';

const props = defineProps({
  content: {
    type: String,
    default: ''
  },
  emptyText: {
    type: String,
    default: 'Não informado'
  }
});

const processedContent = computed(() => {
  if (!props.content || props.content.trim() === '' || props.content === '<p><br></p>') {
    return `<p class="empty-placeholder">${props.emptyText}</p>`;
  }
  return shortenLinks(props.content);
});
</script>

<style>
/* Estilos NÃO-scoped para que afetem o conteúdo v-html */
.summernote-display {
  line-height: 1.6;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.summernote-display .empty-placeholder {
  color: #9ca3af;
  font-style: italic;
}

.summernote-display p {
  margin: 0 0 0.5em 0;
  line-height: 1.6;
}

.summernote-display p:last-child {
  margin-bottom: 0;
}

.summernote-display b,
.summernote-display strong {
  font-weight: 700;
}

.summernote-display i,
.summernote-display em {
  font-style: italic;
}

.summernote-display u {
  text-decoration: underline;
}

.summernote-display ul,
.summernote-display ol {
  margin: 0.5em 0;
  padding-left: 1.5em;
}

.summernote-display ul {
  list-style-type: disc;
}

.summernote-display ol {
  list-style-type: decimal;
}

.summernote-display li {
  margin-bottom: 0.25em;
}

.summernote-display a {
  color: #2563eb;
  text-decoration: none;
}

.summernote-display a:hover {
  text-decoration: underline;
}

.summernote-display br {
  display: block;
  content: "";
}
</style>
